import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Alert, Skeleton, Spin } from "antd";
import { memo, useCallback, useMemo } from "react";

interface DefaultEditEntityProps {
  query: Function;
  editMutation: Function;
  editor: (saveCallback: (data: any) => Promise<boolean>, initialData: any) => JSX.Element;
  stayOnEditAfterSave?: boolean;
}

const DefaultEditEntity = memo(({ query, editMutation, editor, stayOnEditAfterSave = false }: DefaultEditEntityProps) => {
  const navigate = useNavigate();
  const params = useParams();
  const entityId = params.recordId ? params.recordId : 0;

  const location = useLocation();
  const locationState = location.state as any;

  const { data, isFetching } = query(entityId);

  const entity = useMemo(() => data ?? locationState?.record ?? null, [data, locationState]);

  const [editEntity] = editMutation();

  const save = useCallback(
    async (model: any) => {
      try {
        await editEntity(model).unwrap();
        if (!stayOnEditAfterSave) {
          navigate(location.pathname.replace("/edit", ""), {
            state: location.state,
          });
        }
        return true;
      } catch {
        return false;
      }
    },
    [editEntity, location, navigate, stayOnEditAfterSave]
  );

  return (
    <Spin spinning={isFetching}>
      {entity ? (
        editor(save, entity)
      ) : isFetching ? (
        <Skeleton active />
      ) : (
        <Alert type="warning" className="lg:w-1/2" message="رکورد مورد نظر پیدا نشد!" />
      )}
    </Spin>
  );
});

export const GetDefaultEditEntity =
  ({ query, editMutation, editor, stayOnEditAfterSave }: DefaultEditEntityProps) =>
  () =>
    <DefaultEditEntity
      query={query}
      editMutation={editMutation}
      editor={editor}
      stayOnEditAfterSave={stayOnEditAfterSave}
    />;
